<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm" id="rabbrs"><a class="xref" href="#/chilampert0007#abbrs">Abbreviations</a></p>
<p class="toc" id="rintro"><a class="xref" href="#/chilampert0008#intro">Introduction</a></p>
<p class="tocpt" id="rpt01"><a class="xref" href="#/chilampert0009#pt01"><span class="sm">PART</span> <span class="sm">1</span>  Young Nietzsche in the Service of Schopenhauer and Wagner</a></p>
<p class="toc" id="rch01"><a class="xref" href="#/chilampert0010#ch01">1  <i>The Birth of Tragedy</i>: Prometheus the Knowing Maker of Culture</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/chilampert0011#ch02">2  Backgrounds of <i>Schopenhauer as Educator</i></a></p>
<p class="toc" id="rch03"><a class="xref" href="#/chilampert0012#ch03">3  What a Philosopher Is: <i>Schopenhauer as Educator</i></a></p>
<p class="toc" id="rch04"><a class="xref" href="#/chilampert0013#ch04">4  What an Artist Is: <i>Richard Wagner in Bayreuth</i></a></p>
<p class="tocpt" id="rpt02"><a class="xref" href="#/chilampert0014#pt02"><span class="sm">PART</span> <span class="sm">2</span>  A New Public Nietzsche: Enlightenment Optimist</a></p>
<p class="toc" id="rch05"><a class="xref" href="#/chilampert0015#ch05">5  Backgrounds of <i>Things Human All Too Human</i></a></p>
<p class="toc" id="rch06"><a class="xref" href="#/chilampert0016#ch06">6  The Philosopher as Free-Minded Enlightenment Optimist</a></p>
<p class="toc" id="rch07"><a class="xref" href="#/chilampert0017#ch07">7  An Enlightenment Optimist’s View of the Future of Morality, Religion, and Art</a></p>
<p class="toc" id="rch08"><a class="xref" href="#/chilampert0018#ch08">8  An Enlightenment Optimist’s View of the Transformation of Culture</a></p>
<p class="tocpt" id="rpt03"><a class="xref" href="#/chilampert0019#pt03"><span class="sm">PART</span> <span class="sm">3</span>  Nietzsche Enters His Mature Philosophy</a></p>
<p class="toc" id="rch09"><a class="xref" href="#/chilampert0020#ch09">9  “<i>Sanctus Januarius</i>”: The First Work of Nietzsche’s Maturity</a></p>
<p class="toc" id="rch10"><a class="xref" href="#/chilampert0021#ch10">10  The Opening of “<i>Sanctus Januarius</i>”</a></p>
<p class="toc" id="rch11"><a class="xref" href="#/chilampert0022#ch11"><span class="page" id="pviii"></span>11  The Center of “<i>Sanctus Januarius</i>”</a></p>
<p class="toc" id="rch12"><a class="xref" href="#/chilampert0023#ch12">12  Backgrounds to the Center of “<i>Sanctus Januarius</i>”</a></p>
<p class="toc" id="rch13"><a class="xref" href="#/chilampert0024#ch13">13  The Ending of “<i>Sanctus Januarius</i>”</a></p>
<p class="toc" id="rch14"><a class="xref" href="#/chilampert0025#ch14">14  Backgrounds to the Ending of “<i>Sanctus Januarius</i>”</a></p>
<p class="tocf" id="rconc"><a class="xref" href="#/chilampert0026#conc">Conclusion. The Philosophy and Art of Nietzsche’s Maturity</a></p>
<p class="tocbmf" id="rwrk_ctd"><a class="xref" href="#/chilampert0027#wrk_ctd">Works Cited</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/chilampert0028#index">Index</a></p>
<p class="tocbm" id="rfn_notes"><a class="xref" href="#/chilampert0029#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lampert-0006.vue?270910e2